export const MailLogsStatus = {
  SENT: "sent",
  PENDING: "pending",
  ERROR: "error",
  CANCELLED: "cancelled",
} as const;

export type MailLogsStatus =
  (typeof MailLogsStatus)[keyof typeof MailLogsStatus];

export interface MailLogAttachmentDict {
  filename?: string;
  path?: string;
  id?: number | null;
  mimetype?: string;
}

export type MailLogAttachment = string | MailLogAttachmentDict;

export interface MailLogRecap {
  bien?: string;
  locataire?: string;
  meta?: Record<string, unknown> | null;
}

export interface MailLog {
  id: number;
  subject: string;
  destinataire: string;
  cc?: string;
  status: MailLogsStatus;
  sent_at?: string;
  scheduled_at?: string;
  plain?: string;
  html?: string;
  attachments: MailLogAttachment[];
  recap?: MailLogRecap | null;
}
